import { FooterLinks } from "@components/foundation/Footer";
import { HumanloopLogo } from "components/library/Logos";
import NewsletterSignUp from "./NewsletterSignUp";

export const Footer = () => {
  return (
    <div>
      <div className="container-xl flex flex-col items-start justify-between gap-y-32 py-60 sm:py-120 xl:flex-row">
        <div className="mr-120 grow">
          <HumanloopLogo className="h-28 shrink-0" />
        </div>
        {/* Links */}
        <div className="grid w-full shrink grid-cols-2 gap-y-32 md:grid-cols-4">
          {Object.entries(FooterLinks).map(([section, links]) => (
            <div
              key={section}
              className="flex flex-col justify-start gap-8 text-14-20"
            >
              <span className="text-gray-600">{section}</span>
              {links.map(({ title, url, display }) => (
                <a
                  key={title}
                  href={url}
                  className="text-gray-900 hover:underline"
                >
                  {display || title}
                </a>
              ))}
            </div>
          ))}
        </div>
        <div className="grow">
          <NewsletterSignUp />
        </div>
      </div>

      <div className="shrink">
        <div className="container-xl flex justify-between gap-12 border-t border-gray-300 py-24 text-11-14 text-gray-600 sm:py-36 sm:text-14-16">
          <div>© 2020 - 2045 Humanloop, Inc.</div>
          <div className="flex gap-32">
            <a href={"/policies"} className="hover:text-gray-900">
              Terms & Policies
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
